"use strict";

export var FormEditTableConstants = {
  FORM_EDIT_TABLE_FORM_SET_TITLE: 'FORM_EDIT_FORM_SET_TITLE',
  FORM_EDIT_TABLE_FORM_SHOW_TABLE: 'FORM_EDIT_TABLE_FORM_SHOW_TABLE',
  FORM_EDIT_TABLE_FORM_SET_TABLE_ELEM: 'FORM_EDIT_TABLE_FORM_SET_TABLE_ELEM',
  FORM_EDIT_TABLE_FORM_LOAD_BUTTONS_DATA: 'FORM_EDIT_TABLE_FORM_LOAD_BUTTONS_DATA',
  FORM_EDIT_TABLE_FORM_TABLE_INITIALIZED: 'FORM_EDIT_TABLE_FORM_TABLE_INITIALIZED',
  FORM_EDIT_TABLE_FORM_TABLE_BUTTONS_DISABLING: 'FORM_EDIT_TABLE_FORM_TABLE_BUTTONS_DISABLING'
};